<ng-container *ngIf="subjectSessions$ | async as subjectSessions; else loadingState">
  <ng-container *ngIf="subjectSessions.length > 0; else emptyState">
    <!-- Filters -->
    <form [formGroup]="filterFields" class="session-filters form-full-width animated fadeInDown">
      <mat-checkbox [checked]="checkedSubject.checked" [indeterminate]="checkedSubject.indeterminate" (change)="checkSubject()"
        [attr.data-id]="'sessions-select-all'"></mat-checkbox>
      <span class="filter-field" style="flex: 3">
        <mat-form-field appearance="outline" class="solid-background">
          <mat-label>{{ 'subjectSessions.filters.description' | translate }}</mat-label>
          <mat-icon matPrefix class="xs">filter_alt</mat-icon>
          <input type="text" matInput formControlName="description" autocomplete="off" [attr.data-id]="'sessions-description-filter'">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" class="solid-background">
          <mat-label>{{ 'subjectSessions.filters.classification' | translate }}</mat-label>
          <mat-icon matPrefix class="xs">filter_alt</mat-icon>
          <input type="text" matInput formControlName="classification" autocomplete="off" [attr.data-id]="'sessions-classification-filter'">
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" aria-label="File Type" class="solid-background">
          <mat-select formControlName="fileType" class="muted" [attr.data-id]="'sessions-type-dropdown'">
            <mat-option value="">{{ 'subjectSessions.filters.types' | translate }}</mat-option>
            <mat-option *ngFor="let fileType of fileTypes" [value]="fileType">{{ fileType }}</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </form>

    <!-- Data -->
    <div *ngFor="let session of filteredSessions$ | async" class="session-card animated fadeInUp">
      <div class="session-header">{{ session.label }}</div>
      <ng-container *ngIf="session.acquisitions?.length > 0; else emptyStateAcquisitions">
        <acquisition-files *ngFor="let acquisition of session.acquisitions"
          [acquisition]="acquisition" [session]="session"
          [checked]="isAcquisitionChecked(session._id, acquisition._id)" (checkedChange)="checkAcquisition(session._id, acquisition._id)"></acquisition-files>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingState>
  <div *ngIf="!error; else errorState" class="loading-state">
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="blank-state">
    <mat-icon>list</mat-icon>
    <p>{{ 'subjectSessions.states.empty' | translate }}</p>
  </div>
</ng-template>

<ng-template #emptyStateAcquisitions>
  <div class="info-message">
    <div class="fab">
      <mat-icon>list</mat-icon>
    </div>
    <p>{{ 'subjectSessions.states.emptyAcqs' | translate }}</p>
  </div>
</ng-template>

<ng-template #errorState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>error_outline</mat-icon>
    </div>
    <p>{{ 'subjectSessions.states.error' | translate }}</p>
    <button mat-flat-button (click)="loadSessions()" color="primary">{{ 'subjectSessions.buttons.reload' | translate }}</button>
  </div>
</ng-template>
